'use client'

import { useEffect } from 'react'

// NEXT_PUBLIC_VERBOSE_ERRORS=0 으로 빌드하면 상세를 숨기고 digest만 노출합니다.
const VERBOSE = process.env.NEXT_PUBLIC_VERBOSE_ERRORS !== '0'

interface Props {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang="ko">
      <body style={{ margin: 0, fontFamily: 'ui-monospace, monospace', background: 'white' }}>
        <div style={{ minHeight: '100vh', padding: 32, color: '#18181b', fontSize: 13 }}>
          <header style={{ marginBottom: 16 }}>
            <h1 style={{ fontSize: 15, fontWeight: 700, color: '#dc2626', margin: 0 }}>
              Teacher · 치명적 예외 (root layout)
            </h1>
            <p style={{ fontSize: 11, color: '#71717a', marginTop: 4 }}>
              {VERBOSE
                ? '테스트 모드: 상세 정보를 그대로 표시합니다.'
                : '예기치 못한 오류가 발생했습니다.'}
            </p>
          </header>

          {VERBOSE ? (
            <section style={{ maxWidth: 960, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <Field label="message">{error.message || '(empty)'}</Field>
              {error.digest && <Field label="digest">{error.digest}</Field>}
              <Field label="stack" smaller>
                {error.stack || '(empty)'}
              </Field>
            </section>
          ) : (
            error.digest && (
              <section style={{ maxWidth: 480 }}>
                <Field label="reference">{error.digest}</Field>
              </section>
            )
          )}

          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: 20,
              fontSize: 12,
              padding: '6px 12px',
              borderRadius: 6,
              background: '#18181b',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            다시 시도
          </button>
        </div>
      </body>
    </html>
  )
}

function Field({
  label,
  smaller,
  children,
}: {
  label: string
  smaller?: boolean
  children: React.ReactNode
}) {
  return (
    <div>
      <div
        style={{
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          fontWeight: 600,
          color: '#71717a',
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <pre
        style={{
          background: '#fafafa',
          border: '1px solid #e4e4e7',
          borderRadius: 4,
          padding: 8,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          margin: 0,
          fontSize: smaller ? 11 : 13,
        }}
      >
        {children}
      </pre>
    </div>
  )
}
